import { defineComponent } from 'vue';
import { DatePicker } from '@/type';
import moment from 'moment';
import flatpickr from 'flatpickr';

interface Flatpickr extends DatePicker {
  set(option: string, value: any): void;
}

interface Data {
  flatpickr: Flatpickr|null,
  mode: string,
}

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    modelValue: String,
    format: {
      type: String,
      default: 'YYYY/MM/DD',
    },
    minDate: [String, Date],
    maxDate: [String, Date],
  },
  data(): Data {
    return {
      flatpickr: null,
      mode: 'single',
    };
  },
  computed: {
    humanValue(): string|null {
      return this.modelValue ? this.formatValue(this.modelValue) : null;
    },
  },
  watch: {
    minDate(minDate: string|Date|null) {
      if (this.flatpickr) {
        this.flatpickr.set('minDate', minDate);
      }
    },
    maxDate(maxDate: string|Date|null) {
      if (this.flatpickr) {
        this.flatpickr.set('maxDate', maxDate);
      }
    },
  },
  methods: {
    open(): void {
      if (this.flatpickr) {
        this.flatpickr.open();
      }
    },
    clear(): void {
      if (this.flatpickr) {
        this.flatpickr.clear();
      }
    },
    formatValue(value: string): string {
      return moment(value).format(this.format);
    },
    onChange(dates: string[]) {
      const date = moment(dates[0]).format('YYYY-MM-DD');
      this.$emit('update:modelValue', date);
    },
  },
  mounted(): void {
    // @ts-ignore
    this.flatpickr = flatpickr(this.$el, {
      defaultDate: this.defaultValue || this.modelValue,
      minDate: this.minDate,
      maxDate: this.maxDate,
      mode: this.mode,
      onChange: this.onChange,
    });
  },
});
